import { authLogger } from "../utils/logger";
import { signIn, signOut, getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

export const authService = {
  /**
   * Sign in with username and password
   */
  signIn: async (username: string, password: string) => {
    try {
      const { isSignedIn, nextStep } = await signIn({ username, password });
      
      if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        return {
          challengeName: 'NEW_PASSWORD_REQUIRED',
          username
        };
      }
      
      return { isSignedIn, username };
    } catch (error) {
      authLogger.error('Error signing in:', error);
      throw error;
    }
  },

  /**
   * Sign out the current user
   */
  signOut: async () => {
    try {
      await signOut();
    } catch (error) {
      authLogger.error('Error signing out:', error);
      throw error;
    }
  },

  /**
   * Get the current authenticated user
   */
  getCurrentUser: async () => {
    try {
      return await getCurrentUser();
    } catch (error) {
      authLogger.error('Error getting current user:', error);
      return null;
    }
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: async () => {
    try {
      await getCurrentUser();
      return true;
    } catch (error) {
      return false;
    }
  },

  /**
   * Get the current session
   */
  getCurrentSession: async () => {
    try {
      return await fetchAuthSession();
    } catch (error) {
      authLogger.error('Error getting current session:', error);
      return null;
    }
  },

  /**
   * Get JWT token for API calls
   */
  getJwtToken: async () => {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.accessToken?.toString();
    } catch (error) {
      authLogger.error('Error getting JWT token:', error);
      return null;
    }
  },

  /**
   * Get refresh token
   */
  getRefreshToken: async () => {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.refreshToken?.toString();
    } catch (error) {
      authLogger.error('Error getting refresh token:', error);
      return null;
    }
  }
};
